import moment from "moment";
import { useContext, useEffect, useState } from "react";
import Sidebar from "../sidebar";
import {
  getLatestOrders,
  getOrdersCount,
  getSampleProductsCount,
  getStockProductsCount,
} from "./dashboard-section.service";
import {
  downloadOrderExcel,
  downloadOrderXML,
} from "../orders/orders-section.service";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";

interface Order {
  id: string;
  orderNumber: string;
  createdAt: string;
  user: {
    firstName: string;
    lastName: string;
  };
}

export default function DashboardSection() {
  const [products, setProducts] = useState(0);
  const [orders, setOrders] = useState(0);
  const [sampleProducts, setSampleProducts] = useState(0);
  const [latestOrders, setLatestOrders] = useState<Order[]>([]);
  const { user } = useContext(AuthContext);

  console.log(user);

  useEffect(() => {
    const fetchData = async () => {
      const [
        latestOrdersResponse,
        stockProductsCountResponse,
        ordersCountResponse,
        sampleProductsCountResponse,
      ] = await Promise.all([
        getLatestOrders(),
        getStockProductsCount(),
        getOrdersCount(),
        getSampleProductsCount(),
      ]);

      setLatestOrders(latestOrdersResponse.data);
      setProducts(stockProductsCountResponse.data);
      setOrders(ordersCountResponse.data);
      setSampleProducts(sampleProductsCountResponse.data);
    };

    fetchData();
  }, []);

  const handleDownloadExcel = (orderId: string) => {
    downloadOrderExcel(orderId).then((response: any) => {
      const data = new Uint8Array(response.data.data);
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      const date = moment().format("DD-MM-YYYY HH:mm");
      link.setAttribute("download", `order_${date}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  const handleDownloadXML = (orderId: string) => {
    downloadOrderXML(orderId).then((response: any) => {
      const data = new Uint8Array(response.data.data);
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      const date = moment().format("DD-MM-YYYY HH:mm");
      link.setAttribute("download", `order_${date}.xml`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="ec-vendor-dashboard-sort-card color-blue">
                  <h5>Stock Product</h5>
                  <h3>{products}</h3>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="ec-vendor-dashboard-sort-card color-pink">
                  <h5>Orders</h5>
                  <h3>{orders}</h3>
                </div>
              </div>
              {user.isShowSample || user.userType === "Super Admin" ? (
                <div className="col-lg-3 col-md-6">
                  <div className="ec-vendor-dashboard-sort-card color-green">
                    <h5>Sample Product</h5>
                    <h3>{sampleProducts}</h3>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Latest Order</h5>
              </div>
              <div className="ec-vendor-card-body">
                <div className="ec-vendor-card-table">
                  <table className="table ec-table">
                    <thead>
                      <tr>
                        <th scope="col">Order Number</th>
                        <th scope="col">Buyer Name</th>
                        <th scope="col">Submit Date</th>
                        <th scope="col">Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {latestOrders.map((order) => (
                        <tr key={order.id}>
                          <th scope="row">
                            <Link to={`/admin/orders/${order.id}`}>
                              <span>
                                #{" "}
                                {order.orderNumber.toString().padStart(5, "0")}
                              </span>
                            </Link>
                          </th>
                          <td>
                            <span>
                              {order.user?.firstName} {order.user?.lastName}
                            </span>
                          </td>
                          <td>
                            <span>
                              {moment(order.createdAt).format("DD/MM/YYYY")}
                            </span>
                          </td>
                          <td>
                            <span className="d-flex">
                              <button
                                className="btn btn-primary mr-1"
                                onClick={() => handleDownloadExcel(order.id)}
                              >
                                Cart
                              </button>
                              <button
                                className="btn btn-primary"
                                onClick={() => handleDownloadXML(order.id)}
                              >
                                XML
                              </button>
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
